<template>
  <div class="column agent-info bg-light-blue-1">
    <div class="col q-mb-sm">
      <div class="row q-px-xs q-pt-sm">
        <div class="col">
          <div class="column">
            <div
              class="col"
              :key="`spinner${loading}`"
            >
              <q-spinner-dots
                v-if="loading"
                size="xs"
                color="blue-grey-10"
                class="q-ml-md"
                indeterminate
              />
              <span
                v-else
                class="col label-name text-blue-grey-10"
              >{{ agentName }}</span>
            </div>

            <div class="col">
              <div class="row items-baseline">
                <div class="col-auto q-mr-xs">
                  <span class="label-status text-grey-7">{{ agentStatus }}</span>
                </div>
                <div class="col">
                  <StatusIcon :class="['round', colorStatus]" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="!isAdmin"
          class="self-center q-pb-xs cursor-pointer q-mr-xs"
          @click="handlePreview"
        >
          <q-icon
            name="mdi-face-agent"
            size="sm"
            color="#8E8E8E"
          >
            <q-tooltip>Preview</q-tooltip>
          </q-icon>
        </div>

        <div
          class="col-auto q-pb-xs q-pr-sm self-center cursor-pointer"
          @click="handleCalendar"
        >
          <q-icon
            name="mdi-calendar-account"
            size="sm"
            color="#8E8E8E"
          >
            <q-tooltip>Agenda</q-tooltip>
            <q-badge
              rounded
              v-if="todayNotifications.length"
              color="red"
              :label="todayNotifications.length"
              floating
            />
          </q-icon>
        </div>
        <div class="self-center ">
          <router-link :to="{ name: ROUTE_SETTINGS }">
            <SettingIcon class="settings-icon" />
          </router-link>
        </div>
      </div>
    </div>

    <div
      class="col q-ml-xs q-mb-sm"
      v-if="locationSummaryAgent !== 'rodape'"
    >
      <div class="row content-around">
        <div class="col">
          <div class="column items-center">
            <div class="col label-timer">
              <TimerSeconds
                :value="agent.summary.loginSecs"
              />
            </div>

            <div class="col">
              <span class="label-timer-title">LOGADO</span>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="column items-center">
            <div class="col label-timer">
              <TimerSeconds
                v-if="agent.inAttendance"
                :value="agent.summary.callSecs"
              />
              <TimerLabel
                v-else
                :seconds="agent.summary.callSecs"
              />
            </div>

            <div class="col">
              <span class="label-timer-title">ATENDIMENTO</span>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="column items-center">
            <div class="col label-timer">
              <TimerSeconds
                v-if="agent.paused"
                :value="agent.summary.pauseSecs"
              />

              <TimerLabel
                v-else
                :seconds="agent.summary.pauseSecs"
              />
            </div>
            <div class="col">
              <span class="label-timer-title">PAUSA</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="col q-ml-xs q-mb-sm"
      v-if="locationSummaryAgent !== 'rodape'"
    >
      <div class="row content-around">
        <div class="col">
          <div class="column items-center">
            <div class="col label-timer">
              <span>{{ totalAttendances || '-' }}</span>
            </div>

            <div class="col">
              <span class="label-timer-title">
                {{ totalAttendances === 1 ? 'ATENDIMENTO' : 'ATENDIMENTOS' }}</span>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="column items-center">
            <div class="col label-timer">
              <TimerLabel :seconds="averageReceptiveOperation" />
            </div>
            <div class="col">
              <span class="label-timer-title">TMO R</span>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="column items-center">
            <div class="col label-timer">
              <TimerLabel :seconds="averageActiveOperation" />
            </div>
            <div class="col">
              <span class="label-timer-title">TMO A</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { ROUTE_SETTINGS, ROUTE_CALENDAR, ROUTE_PREVIEW, ROUTE_PREVIEW_DETAILS, ROUTE_PREVIEW_CURRENT } from '@/router/constants'
import { DIRECTION_OUT } from '@/constants/directions'
import TimerLabel from '@/components/TimerLabel'
import TimerSeconds from '@/components/TimerSeconds'
import StatusIcon from '@/assets/icons/statusIcon.svg'
import SettingIcon from '@/assets/icons/settings.svg'

export default {
  components: {
    TimerLabel,
    TimerSeconds,
    StatusIcon,
    SettingIcon
  },

  data () {
    return {
      colorStatus: 'online',
      pauseReasonDescription: '',
      agentStatuses: {
        ONLINE: 'Online',
        OFFLINE: 'Offline',
        PAUSED: 'Pausa',
        CONNECTED: 'Em atendimento'
      },
      ROUTE_SETTINGS
    }
  },
  computed: {
    ...mapState({
      current: (state) => state.attendanceModule.current,
      attendanceHistory: (state) => state.attendanceModule.history,
      agent: (state) => state.agentModule.session.agent,
      loading: (state) => state.agentModule.session.loading,
      locationSummaryAgent: (state) => state.settingsModule.locationSummaryAgent,
      pauseReasons: (state) => state.agentModule.session.pauseReasons,
      agentGeral: (state) => state.agentModule,
      agentStatus ({ agentModule }) {
        const { session } = agentModule
        this.colorStatus = 'online'

        if (this.agent.pauseReasonId && (session?.agent?.status !== 'ONLINE')) {
          const pauseReasons = this.pauseReasons.reduce((acc, pauseReason) => {
            acc[pauseReason.id] = pauseReason
            return acc
          }, {})

          const pauseReasonId = this.agent?.pauseReasonId ?? ''
          const description = [null, undefined, '', false].includes(pauseReasonId) ? '' : pauseReasons[pauseReasonId]?.description ?? ''
          const objDescription = Object.assign(this.agentStatuses, { description: description })
          this.agentStatuses = objDescription
          this.colorStatus = 'offline'

          return this.agentStatuses.description
        }

        if (Object.keys(this.current).length >= 1) {
          const arrayValues = Object.values(this.current)
          const status = arrayValues.some((a) => ['HOLD', 'CONNECTED'].includes(a.status)) ? 'CONNECTED' : 'ONLINE'

          this.colorStatus = status === 'CONNECTED' ? 'ongoing' : 'online'

          return this.agentStatuses[status]
        }

        return this.agentStatuses[session?.agent?.status]
      },

      agentName ({ agentModule }) {
        const agent = agentModule?.session?.agent
        if (!agent) return ''

        return agent?.fullname ?? agent?.name ?? ''
      },

      isAgentBusy ({ agentModule }) {
        const { session } = agentModule
        const agentStatus = String(session?.agent?.status || '').trim().toUpperCase()
        const isRinging = agentStatus.includes('DIALING')
        const isOnline = agentStatus.includes('ONLINE')
        return !isOnline || isRinging
      }
    }),

    ...mapGetters({
      todayNotifications: 'calendarModule/todayNotifications',
      isAdmin: 'settingsModule/isAdmin',
      previewQueue: 'attendanceModule/previewQueue'
    }),

    totalAttendances () {
      return Object.keys(this.attendanceHistory).length
    },

    averageActiveOperation () {
      return this.calculateAverageOperation((a) => a.direction === DIRECTION_OUT && a.hangupAt)
    },

    averageReceptiveOperation () {
      return this.calculateAverageOperation((a) => a.direction !== DIRECTION_OUT && a.hangupAt)
    }
  },

  methods: {
    calculateAverageOperation (filter) {
      const values = Object.values(this.attendanceHistory)
        .filter(filter)
      const total = values.reduce((a, b) => {
        return a + (b.hangupAt - b.createdAt)
      }, 0) / values.length

      return (total / 1000) || 0
    },
    handleCalendar () {
      this.$router.push({ name: ROUTE_CALENDAR }).catch(() => { })
      this.$root.$emit('focus-target-destination')
    },

    handlePreview () {
      const routeName = this.$route.name

      const routeToPreview = () => routeName !== ROUTE_PREVIEW && this.$router.push({ name: ROUTE_PREVIEW })
      const routeToDetail = () => routeName !== ROUTE_PREVIEW_DETAILS && this.$router.push({ name: ROUTE_PREVIEW_DETAILS, params: { queueId: this.previewQueue } })
      const routeToCurrent = (attendanceId) => routeName !== ROUTE_PREVIEW_CURRENT && this.$router.push({ name: ROUTE_PREVIEW_CURRENT, params: { queueId: this.previewQueue, attendanceId } })

      if (!this.previewQueue) {
        routeToPreview()
        this.$root.$emit('focus-target-destination')
        return
      }

      const previewIsDialing = this.$store.state.attendanceModule.preview.status === 'DIALING'
      const callInPreview = Array.from(this.$store.state.attendanceModule.preview.attendances)[0]

      if (previewIsDialing || callInPreview) {
        routeToCurrent(callInPreview)
        this.$root.$emit('focus-target-destination')
        return
      }

      routeToDetail()

      this.$root.$emit('focus-target-destination')
    }
  }
}
</script>

<style lang="sass" scoped>
.round
  width: 8px
  height: 8px

.online > circle
  fill: #21BA45

.offline > circle
  fill: #D32F2F

.ongoing > circle
  fill: #FFC107

.settings-icon
  width: 18px
  height: 18px

.settings-icon > path
  fill: #37474F

.label-name
  font-style: normal
  font-weight: 500
  font-size: 13px
  line-height: 15px

.label-status
  font-style: normal
  font-weight: normal
  font-size: 12px
  line-height: 14px

.label-timer-title
  font-style: normal
  font-weight: normal
  font-size: 10px
  line-height: 12px
  color: #757575

.label-timer
  font-style: normal
  font-weight: normal
  font-size: 13px
  line-height: 15px
  color: #263238

.agent-info
 font-size: 11px

</style>
